import React, { useState } from "react";
import "../../styles/styles.css";
import { SimpleQuiz } from "../SimpleQuizz/SimpleQuiz";

import { detailedQuizz, simpleQuizz } from "../../data/quizzVersions";
import { QuizzChoice } from "./QuizzChoice";

//Définition de la page d'accueil du questionnaire

export const Homepage = ({ email }) => {
  const [quizzIdChosen, setQuizzIdChosen] = useState();

  if (quizzIdChosen === simpleQuizz.id) {
    return <SimpleQuiz email={email} />;
  }
  if (quizzIdChosen === detailedQuizz.id) {
    return <h1> En chantier </h1>;
  }

  return <QuizzChoice handleClickOnQuizzVersion={setQuizzIdChosen} />;
};

export default Homepage;
